import React, { useState, useEffect, useContext } from 'react';

export default function Profile() {
  return (
    <>
      <h1>Profile</h1>
    </>
  );
}
